import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';
import PracticeReserveSubmitConfirm from './confirm/PracticeReserveSubmitConfirm';


// 予約ボタン
function PracticeReserveSubmit() {

  const {
    formRef, selectedScheduleId, selectedSituation,
  } = useContext(PracticeReseveContext);

  const [canReserve, setCanReserve] = useState<boolean>(false);
  const [isDispConfirm, setIsDispConfirm] = useState<boolean>(false);


  useEffect(() => {
    if(selectedScheduleId && selectedSituation) {
      setCanReserve(true);
    } else {
      setCanReserve(false);
    }
  }, [selectedScheduleId, selectedSituation])


  const onPress = () => {
    if(canReserve) {
      // 予約確認
      setIsDispConfirm(true);
    } else {
      // 予約不可→formへスクロール
      formRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }


  return (
    <p className="text-center">
      {/* 予約ボタン */}
      <button
        type="button"
        className="btn btn-primary btn_customize btn_lg"
        style={{
          width: '80%',
          fontSize: '130%',
          letterSpacing: '0.05em',
          ...( !canReserve
            ? { backgroundColor: '#7d7d7d' }
            : {}
          )
        }}
        onClick={onPress}
      >
        予約する <i className="fas fa-chevron-circle-right"></i>
      </button>

      {/* 確認モーダル */}
      <PracticeReserveSubmitConfirm
        isDispConfirm={isDispConfirm}
        setIsDispConfirm={setIsDispConfirm}
      />
    </p>
  );
}
  
export default PracticeReserveSubmit;